import React from 'react';
import {useIntl} from 'react-intl';

import {useGeneralProvider} from 'brand/app/components/_app-config/GeneralProvider';

import messages from './messages';

import styles from './PreorderPopupButton.module.scss';

const PreorderPopupButton = () => {
	const {managerRepository} = useGeneralProvider();
	const intl = useIntl();

	const handleClick = () => {
		managerRepository.getPopupsMgr().openPopup('preorder');
	};

	return (
		<span
			className={styles['preorder-popup-button']}
			onClick={handleClick}
		>
			{intl.formatMessage(messages.popupButtonText)}
		</span>
	);
};

export default PreorderPopupButton;
